import { render, staticRenderFns } from "./accessInformation.vue?vue&type=template&id=44bd0fac&scoped=true"
import script from "./accessInformation.vue?vue&type=script&lang=js"
export * from "./accessInformation.vue?vue&type=script&lang=js"
import style0 from "./accessInformation.vue?vue&type=style&index=0&id=44bd0fac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bd0fac",
  null
  
)

export default component.exports